import { render, staticRenderFns } from "./SubprocessorTable.vue?vue&type=template&id=47aef096&"
import script from "./SubprocessorTable.vue?vue&type=script&lang=js&"
export * from "./SubprocessorTable.vue?vue&type=script&lang=js&"
import style0 from "./SubprocessorTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports